import(/* webpackMode: "eager" */ "/home/ubuntu/download_staging/69ba99377d947e001469cf93/upskill_1773836599114/src/app/home/page.tsx");
